module.exports = __webpack_public_path__ + "static/media/walking-with-horse.f8a6125c.jpg";